<template>
	<div class="aside_right">
		<div class="teplate_tit">
			<div class="teplate_tits" @click="saveId"> + 制作内容</div>
			<div class="conlist clearfix" v-for="(item,key) in inforShow" v-cloak>
				<div class="list_tit clearfix">
					<div class="tits fl_left">{{item.json_data.bg_title}}</div>
					<div class="music_icon fl_left">
						<div class="music fl_left" v-if="item.json_data.music" v-for="(itemMusic,keyMusic) in item.json_data.music" @click="get_play($event,itemMusic.src)" :class="{zcir:itemMusic.src == music}"></div>
					</div>
					<div class="bkxq_wrapper fl_right" @click="xq_show($event,key)"  v-if="item.have_explain == 1">
						教学详解<i class="el-icon-arrow-right"></i>
					</div>
					<div class="xq_box" @click.stop="xgContent($event,2,key)">
						<div class="teplate_tit" style="margin-top: 20px;padding-top: 0;">
							<div class="xq_del" @click="xq_hide($event)"></div>
							<div class="xq_list" v-for="(itemBkxq,ky) in inforShow1">
								<div class="clearfix">
									<div class="xqTit fl_left">{{itemBkxq.title}}</div>
									<div class="music_icon fl_left">
										<div class="music fl_left" v-for="(itemMusicq,keysMusic) in itemBkxq.music" @click="get_play($event,itemMusicq.src)" :class="{zcir:itemMusicq.src == music}"> 
											<audio :src="itemMusicq.src" class="play"></audio>
										</div>
									</div>
								</div>
								<div class="xqCon">
									<div v-html="itemBkxq.bg_text"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="list_wb">
					<div class="wb_con">
						<div class="wb_tit" v-html="item.json_data.bg_text">{{item.json_data.bg_text}}</div>
					</div>
				</div>
				
				<div class="editor_dele">
					<el-button icon="el-icon-edit" size="mini" @click="xgContent($event,1,key)" >编辑</el-button>
					<el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteSection(item.id,key)" >删除</el-button>
				</div>
			</div>
		</div>
		<div class="mark_wrap" v-if="lmcon">
			<div class="tishi_Infor">
				<div class="tishi_con">请先添加左侧栏目</div>
				<div class="tishi_btn" @click="sure">确定</div>
			</div>
		</div>
		<!-- <audio :src="music" class="play"></audio> -->
	</div>
</template>

<script>
//import './../../static/js/videoPlay.js'
	export default{
		data(){
			return{
				feomLsit:this.formData,
				inforShow:[],
				inforShow1:[],
				lmcon:false,
				package:'',
				id:'',
				table_id:'',
				play_pause:false,
				music:"",
				audio:"",
				tiemr:null

			}
		},
		props:['formData'],
		methods:{
			xgContent(e,val,i){
				e.stopPropagation();
				if(val == 2) return 
				const _this = this;
				var tep_crey=JSON.stringify(this.formData)
				localStorage.setItem('template',tep_crey);

				if(sessionStorage.getItem('changeNum')==null){
					var tep_crey=JSON.stringify(this.formData);
					sessionStorage.setItem('formID',JSON.stringify({crey:_this.formData.module_id,conId:_this.inforShow[i].id}))
					_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);
			 		_this.$router.push({
						path:'/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
						name:'wz',
						query:{
							package:this.$route.query.package,
							id:this.$route.query.id,
							table_id:this.$route.query.table_id,
							pocId:this.$route.query.pocId,
						}
					})
				}else{
					sessionStorage.setItem('formID',JSON.stringify({crey:parseInt(sessionStorage.getItem('changeNum')),conId:_this.inforShow[i].id}))
					this.formData.module_id=parseInt(sessionStorage.getItem('changeNum'))
					var tep_crey=JSON.stringify(this.formData);
					_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);
			 		_this.$router.push({
						path:'/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
						name:'wz',
						query:{
							package:this.$route.query.package,
							id:this.$route.query.id,
							table_id:this.$route.query.table_id,
							pocId:this.$route.query.pocId,
						}
					})
				}
			},
			//删除段
			deleteSection(section_id,key){
				let _this=this;
				_this.$confirm('确认删除此段落吗？此操作不可恢复，请确认', '删除提示', {
					onfirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					_this.$axios.post('deletedetail',{
						detail_id:section_id
					}).then((res)=>{
						if(res.data.code == 200)
						{
							_this.$message({type: 'success',message: '删除成功!'});
							this.inforShow.splice(key,1);
						}else{
							_this.$message.error(res.data.message)
						}
					}).catch((err)=>{
						console.log(err)
					})
				}).catch((error) => {     
				});	
			},
			sure(){
				this.lmcon=! this.lmcon
			},
			xq_hide(e){
				e.stopPropagation();
				$('.xq_box').hide()
			},
			xq_show(e,i){
				e.stopPropagation();
				$('.xq_box').show();
				// $('.conlist').find('.music_icon').find('.music').removeClass('zcir')
				// for(var a=0;a<$('.conlist').find('.music_icon').find('.music').length;a++){
				// 	for(var b=0;b<$('.conlist').find('.music_icon').find('.music').eq(a).find('.play').length;b++){
				// 		$('.conlist').find('.music_icon').find('.music').eq(a).find('.play')[b].pause();
				// 	}
				// }
				let _this = this ;
				_this.$axios.post('getexplainlist',{
					detail_id:_this.inforShow[i].id
				}).then( res =>{
					if(res.data.code == 200){
						_this.inforShow1 = res.data.data.json_data
					}
					else{
						_this.$message.error(res.data.message)
					}
				}).catch( error =>{
					console.log(error)
				})
				if(typeof($(document).find('video')[0])== 'object'){
					$(document).find('video')[0].pause()
				}
			},
			saveId(){
				const _this=this;
				var tep_crey=JSON.stringify(this.formData)
				localStorage.setItem('template',tep_crey);
				sessionStorage.removeItem('formID')
				if(sessionStorage.getItem('changeNum')==null){
					// var tep_crey=JSON.stringify(this.formData);
					_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);

					if(_this.formData.lanmu<=0){
				 		_this.lmcon=true;
				 	}else{
				 		_this.lmcon=false;
				 		_this.$router.push({
							path:'/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
							name:'wz',
							query:{
								package:this.$route.query.package,
								id:this.$route.query.id,
								table_id:this.$route.query.table_id,
								pocId:this.$route.query.pocId,
							}
						})
				 	}
				}else{
					this.formData.module_id=parseInt(sessionStorage.getItem('changeNum'))
					// var tep_crey=JSON.stringify(this.formData);
					_this.formData.course_id=_this.$md5("'"+this.formData.course_id+"'")
					// window.localStorage.setItem('template',tep_crey);
					if(_this.formData.lanmu<=0){
				 		_this.lmcon=true;
				 	}else{
				 		_this.lmcon=false;
				 		_this.$router.push({
							path:'/manager/stu_class/class/singleLesson/addKj/makTep/startFrom',
							name:'wz',
							query:{
								package:this.$route.query.package,
								id:this.$route.query.id,
								table_id:this.$route.query.table_id,
								pocId:this.$route.query.pocId,
							}
						})
				 	}
				}
			},
			get_play(e,item){
				e.stopPropagation();
				let _this = this;
				if(item != _this.music && _this.music != "" ){
					_this.play_pause = !_this.play_pause
					_this.audio.pause();
					_this.music = ""
					clearInterval(_this.tiemr);
				}
				if(!_this.play_pause){
					this.audio = new Audio();
					this.audio.src = item;
					var second = this.audio.duration;
					_this.music = item
					let playPromise; 
					playPromise = this.audio.play();
				
					if (playPromise) {
				        playPromise.then(() => {
				            // 音频加载成功
				            // 音频的播放需要耗时
				          	_this.tiemr = setInterval(() => {
				            	second--;
				            	if (second <= 0) {
				              		_this.audio.pause()
				              		_this.music = ""
				              		clearInterval(_this.tiemr);
				            	}
				          	}, 1000);
				        }).catch((e) => {
				          // 音频加载失败
				          console.error(e);
				        });
				    }
				}
				else{
					_this.audio.pause();
					_this.music = ""
					clearInterval(_this.tiemr);
				}
				
				_this.play_pause = !_this.play_pause
			},
			changeRightCon(){
				var _this = this;
				/*if(sessionStorage.getItem('changeNum') != null){
					_this.$axios.post('getdetaillist',{
						column_id:parseInt(sessionStorage.getItem('changeNum'))
					}).then( res =>{
						if(res.data.code == 200){
							_this.inforShow = res.data.data
						}
						else{
							_this.$message.error(res.data.message)
						}
					}).catch( error =>{
						console.log(error)
					})
				}
				else{*/
					_this.$axios.post('getdetaillist',{
						column_id:_this.formData.module_id
					}).then( res =>{
						if(res.data.code == 200){
							_this.inforShow = res.data.data
						}
						else{
							_this.$message.error(res.data.message)
						}
					}).catch( error =>{
						console.log(error)
					})
				// }
			}
		},
		beforeDestroy () {
			var _this = this;
	        _this.play_pause = true
			_this.music = ""
			if(_this.audio != ""){
				_this.audio.pause();
			}
			clearInterval(_this.tiemr);
	    },
		created(){
			var _this = this;
			console.log(this.formData);
			_this.changeRightCon()
		},
		watch:{
			formData:{
				 handler(){
				 	var _this = this;
					 $('.xq_box').hide()
					 _this.changeRightCon()
					 _this.play_pause = true
					 _this.music = ""
					 if(_this.audio != ""){
					 	_this.get_play(event,"")
					 }
					 
				 },
				 deep:true	
			}
		}
	};
</script>
<style scoped>
	.aside_right{
		box-sizing: border-box;
		margin-top: 20px;
		min-height: 500px;
		overflow:auto;
		background: #F7F8FA;
		padding: 20px 0px 40px;
		position: relative;
		font-size: 14px;
		width: 100%;
		overflow-y: hidden;
	}
	.teplate_tits{
		width: 148px;
		height: 44px;
		box-sizing: border-box;
		line-height: 44px;
		text-align: center;
		color: #fff;
		border-radius: 6px;
		border:1px dashed #fff;
		/*background: #cea770;*/
		font-size: 16px;
		cursor: pointer;margin-bottom: 10px;
	}
	.teplate_tits:hover{background: #af8b4c;}
	.teplate_tit{
		overflow-y:auto;
		height: 480px;
		background: #d2b17e;
		padding: 40px;
		overflow-x: hidden;	
		box-sizing: border-box;
		width: 92%;
		margin: 0 auto;
		/*padding:20px 20px 32px;*/
	}
	.teplate_tit::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.teplate_tit::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.teplate_tit::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.list_tit{
		color: #fff;margin: 10px 0;
	}
	.list_wb{
		color: #fff;
		width: 725px;
	}
	.list_wb .wb_tit{
		margin-bottom: 10px;
		font-size: 20px;
		/*color: #666;*/
	}
	.list_wb .wb_tit img{
		display: inline-block;
	}
	.wb_main{
		margin-left: 10px;
		height: 30px;
		line-height: 30px;
	}
	.tits{
		font-size: 22px;
		/*color:  #cea770;*/
	}
	.tits,.music_icon,.bkxq_wrapper{
		height: 45px;
		line-height: 45px;
	}
	.music{
		background: url(../../../../static/imgs/musicicon.png) 0 center no-repeat;
		background-size: 100%;
		width: 28px;
		height: 28px;
		float: left;
		margin-right: 14px;
		cursor: pointer;
	}
	.music_icon{
		display: flex;
		justify-content: center;
		align-items: center;
		height: 45px;
	}
	.music audio{
		display: none;
	}
	.bkxq_wrapper{
		height: 30px;
		line-height: 30px;
		padding: 0 10px;
		text-align: center;
		color: #cea770;
		background: #fff;
		margin-top: 8px;
		cursor: pointer;
		padding-right: 20px;
		background-size: 12px;
	}
	.xq_box{
		position: absolute;
		top: 0;
		left: 0;
		height: 500px;
		overflow:auto;
		width: 100%;
		/*background: rgba(1,171,108,0.6);*/
		/*background: url(../../../../static/imgs/xqbg.png) 0 0 no-repeat;*/
		/*background-attachment: scroll;*/
		box-sizing: border-box;
		/*background-size: cover;*/
		/*padding: 20px 25px 0;*/
		display: none;
		z-index: 99;
		background: #f7f7f8
	}
	.xq_box::-webkit-scrollbar{
		width:4px;
		height: 4px; 
	}
	.xq_box::-webkit-scrollbar-thumb{
		border-radius: 5px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
	}
	.xq_box::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
	}
	.xq_del{
		position: absolute;
		top: 27px;
		right: 42px;
		width: 24px;
		height: 24px;
		background: url(../../../../static/imgs/close_zky.png) 0 0 no-repeat;
		background-size: contain;
		cursor: pointer;
	}
	.xq_list{
		margin-bottom: 20px;
	}
	.xqTit{
		color: #fff;
		font-size: 20px;
		line-height: 45px;
		margin-bottom: 10px;
	}
	.xqCon{
		line-height: 32px;
		margin-bottom: 10px;
		color: #fff;
		/* background: url(../../static/imgs/tn_cir.png) 0 13px no-repeat; */
		background-size: 8px;
	}
	.imgsrc{
		margin-bottom: 10px;
	}
	.imgsrc img{
		max-width: 200px;
		max-height: 143px;
		display: inline-block;
		margin: 0 5px;
		border:none;
	}
	.zcir{
		animation: go 1.5s infinite; 
		animation-fill-mode:both;
	}
	@keyframes go{
		0%{
			transform: rotateZ(0);
		}
		100%{
			transform: rotateZ(360deg);
		}
	}
	.videoSrc{
	width: 255px;
	height: 160px;
	}
	.videoSrc video{
		width: 100%;
		height: 100%;
	}
	.xqImg{
		width: 255px;
		height: 160px;
	}
	.xqImg img{
		width:100%;
		height: 100%;
	}
	.mark_wrap{
		width: 100%;
		height: 100%;	
		background: rgb(245,245,245,0.55);
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.tishi_Infor{
		width:400px;
		height: 150px;
		font-size: 16px;
		background: #fff;
		border-radius: 8px;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		font-family: "微软雅黑"
	}
	.tishi_btn{
		margin-top: 30px;
		cursor: pointer;
		width: 116px;
		height: 32px;
		background: #595DB5;
		text-align: center;
		line-height: 32px;
		border-radius: 4px;
		color: #fff;
	}
	.video-widy{
		width: 230px;
		height: 136px;
	}
	.video-widy video{
		max-width: 230px;
		max-height: 136px;
	}
	.play{display: none;}
	
	.editor_dele{margin: 10px;height: 30px;}
	.conlist {border: 1px dashed #efefef;}
	.conlist:hover {border: 1px dashed #CCcccc;}

</style>


// WEBPACK FOOTER //
// src/components/index/template/zky_modul.vue